import axios from 'axios';
import { responseSuccess, responseError } from './interceptors/response';
import { getToken } from '@/utils/auth';
import { getScheduleToken } from '@/utils/storage/schedule';

// 创建默认的axios实例
const service = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_URL,
  timeout: 30000,
});

// 创建用于GPT接口的axios实例
const gptService = axios.create({
  baseURL: import.meta.env.VITE_APP_GPT_URL,
  timeout: 30000,
});
// 请求拦截
service.interceptors.request.use(
  (config: any) => {
    config.headers['X-Airdoc-Client'] = 'c10b3355-1667-4bfb-bd06-7e7494325c99';
    const token: string = getToken();
    const scheduleToken: string = getScheduleToken();

    if (token) {
      config.headers.Authorization = token;
    }
    // s35 配置三方对接需求
    if (scheduleToken) {
      config.headers.Authorization = scheduleToken;
    }
    // s35 配置三方对接需求
    if (config.scheduleClient) {
      config.headers['X-Airdoc-Client'] = config.scheduleClient;
    }

    return config || {};
  },
  (error) => {
    Promise.reject(error);
  },
);
// 响应拦截
service.interceptors.response.use(responseSuccess as any, responseError);

// 为GPT服务添加拦截器
gptService.interceptors.request.use(
  (config: any) => {
    // config.headers['X-Airdoc-Client'] = 'c10b3355-1667-4bfb-bd06-7e7494325c99';
    // const token: string = getToken();
    // if (token) {
    //   config.headers.Authorization = token;
    // }
    return config || {};
  },
  (error) => {
    Promise.reject(error);
  },
);
gptService.interceptors.response.use(responseSuccess as any, responseError);

export { service as default, gptService };
